import React from 'react';

import styled from 'styled-components';

import { STATUS } from '../../constants';

const StatusMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 180px;
  font-size: 13px;
  color: var(--text-secondary);
  border: 1px solid var(--line-gray);
`;

type Props = {
  availableFlagsCount: number;
  isLoading: boolean;
  status: string;
};

const UserManagementFeatureFlagsModalStatus = ({ availableFlagsCount, isLoading, status }: Props) => {
  if (isLoading) {
    return <StatusMessage>Loading feature flags...</StatusMessage>;
  }

  if (status === STATUS.FAILURE) {
    return <StatusMessage>Unable to load feature flags.</StatusMessage>;
  }

  if (!availableFlagsCount) {
    return <StatusMessage>No feature flags available.</StatusMessage>;
  }

  return null;
};

export default UserManagementFeatureFlagsModalStatus;
